<script setup lang="ts">
import { computed } from 'vue';
import { getFileIconBody, getFolderIconBody, getSymlinkIconBody } from '@/lib/file-icons';

const props = defineProps<{
	name: string;
	folder?: boolean;
	open?: boolean;
	symlink?: boolean;
}>();

const body = computed(() => {
	if (props.symlink) return getSymlinkIconBody(!!props.folder, !!props.open);
	if (props.folder) return getFolderIconBody(props.name, !!props.open);
	return getFileIconBody(props.name);
});
</script>

<template>
	<svg v-if="body" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" v-html="body" />
	<slot v-else />
</template>
